import {
  Component,
  computed,
  EventEmitter,
  input,
  model,
  Output,
} from "@angular/core";
import { ChipsComponent } from "../../modules/chips/chips.component";

@Component({
  selector: "vl-expand-button",
  standalone: true,
  imports: [ChipsComponent],
  templateUrl: "./expand-button.component.html",
  styleUrl: "./expand-button.component.scss",
})
export class ExpandButtonComponent {
  expanded = model<boolean>(false);
  size = input<"small" | "big">("big");
  mode = input<"dark" | "normal">("normal");
  label? = input<string>();

  expandedState = computed(() => {
    return this.mode() === "normal" ? "enabled" : "reverse";
  });
  @Output() expand = new EventEmitter<boolean>();
}
